export const NO_MATCH_CLAIM_PARTY_ID = -1; // claimPartyId when no match selected
